import React from 'react';
import TextInput from '../../form/TextInput';
import createForm from "./Form";
import DateTimeInput from "../../form/DateTimeInput";
import UrlField from "../../form/UrlField";
import Figures from "../../form/Figures";
import Select from "../../form/Select";

class BannerForm extends React.Component {

    render() {
        return (
            <form onSubmit={this.props.handleSubmit}>
                <div className="row form-row">
                    <div className="col-sm-4 col-sm-push-8">
                        <div className="form-group">
                            <TextInput
                                name={this.props.componentConfig.idfield}
                                value={this.props.values[this.props.componentConfig.idfield]}
                                label="Kód"
                                role="idfield"
                                {...this.props.getFieldProps(this.props.componentConfig.idfield)}
                            />
                        </div>
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <div className="form-group">
                            <TextInput
                                name="name"
                                value={this.props.values.name}
                                label="Név"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("name")}
                            />
                        </div>
                    </div>
                    <div className="col-sm-4 col-sm-pull-4">
                        <div className="form-group">
                            <Select
                                name="type"
                                storeType="local"
                                optionname="banner_type"
                                objectValue={false}
                                value={this.props.values.type}
                                label="Típus"
                                saveChanges={this.props.setFieldValue}
                                {...this.props.getFieldProps("type")}
                            />
                        </div>
                    </div>
                </div>
                <div className="row form-row">
                    <div className="col-md-6">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("start_date")}
                                isClearable={true}
                                maxDate={this.props.values.end_date}
                                name="start_date"
                                value={this.props.values.start_date}
                                label="Kezdés"
                                showTime={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="form-group">
                            <DateTimeInput
                                {...this.props.getFieldProps("end_date")}
                                isClearable={true}
                                minDate={this.props.values.start_date}
                                name="end_date"
                                value={this.props.values.end_date}
                                label="Lejárat"
                                showTime={true}
                                saveChanges={this.props.setFieldValue}
                            />
                        </div>
                    </div>
                </div>
                {this.props.componentConfig.fielddefs.url &&
                <UrlField {...this.props}/>}
                <div className="row form-row">
                    <div className="col-sm-12">
                        <Figures
                            name="images"
                            label="Képek"
                            componentConfig={this.props.componentConfig}
                            data={this.props.values}
                        />
                    </div>
                </div>
            </form>
        );
    }
}

export default createForm(BannerForm);
